import React, {Fragment} from 'react';
import {Button, DialogContent, DialogContentText, DialogTitle, Stack} from '@mui/material';

import Image from 'presentation/assets/images/general-lost.svg';
import {Loading} from 'presentation/components/Loading/Loading';
import {RatingStatusEnum} from 'domain/usecases';
import {translations} from 'presentation/translations-new';
import {FiveStarsEnum} from 'main/analytics/gaTagsEnum';
import {ImageContainer, StyledDialog, StyledDialogHeader} from './styles';
import {ErrorNotEvaluating} from './ErrorNotEvaluating';
import {useRatingModal} from '../../hooks/useRatingModals';
import {RefuseEvaluationProps} from './types';

const {
	rateYourAttendance,
	discardRating,
	backToRating,
	dontWantRateDescription,
	dontWantRateTitle,
} = translations['pt-br'].privateFlow.fiveStarsRating;

export function RefuseEvaluation({ratingDetail}: RefuseEvaluationProps) {
	const {handleRefuseToEvaluate, isSubmitting, handleGoToEvaluationPage} = useRatingModal();

	const data = {
		cdatendimento: ratingDetail.keys.cdatendimento,
		cdusuario: ratingDetail.keys.cdusuario,
		tipo: ratingDetail.keys.tipo,
		status: RatingStatusEnum.NEVER_EVALUTE,
	};

	return (
		<Fragment>
			<StyledDialog open={true}>
				<StyledDialogHeader>{rateYourAttendance}</StyledDialogHeader>
				<DialogContent>
					<ImageContainer>
						<img
							src={Image}
							alt="Uma pessoa com uma mochila nas costas e uma lupa na mão, está olhando para uma bifurcação no caminho, sem saber qual direção seguir."
							width={140}
							height={140}
						/>
					</ImageContainer>
					<DialogTitle textAlign="center">{dontWantRateTitle}</DialogTitle>
					<DialogContentText textAlign="center" color="text.primary">
						{dontWantRateDescription}
					</DialogContentText>
				</DialogContent>
				<Stack p={2} gap={1}>
					<Button
						fullWidth
						size="large"
						data-tag-id={FiveStarsEnum.CLICK_VOLTAR_E_REALIZAR_AVALIACAO}
						onClick={() =>
							handleGoToEvaluationPage({
								cdAtendimento: data.cdatendimento,
								tipo: data.tipo,
							})
						}
						disabled={isSubmitting}>
						{backToRating}
					</Button>
					<Button
						fullWidth
						size="large"
						variant="outlined"
						data-tag-id={FiveStarsEnum.CLICK_DESCARTAR_AVALIACAO}
						onClick={() => handleRefuseToEvaluate(data)}
						disabled={isSubmitting}
						endIcon={isSubmitting ? <Loading size={20} color="inherit" /> : null}>
						{discardRating}
					</Button>
				</Stack>
			</StyledDialog>
			<ErrorNotEvaluating ratingDetail={ratingDetail} />
		</Fragment>
	);
}
